import { InputComponentType } from "../../../utils/enums";

export const generalInfoFields = {
  employeeNum: {
    name: "employeeNum",
    label: "Employee ID",
    type: "text",
    required: true,
    component: InputComponentType.TextField,
    isDisabled: (formValues) => formValues.autoGenerateID,
  },
  status: {
    name: "status",
    label: "Status",
    component: InputComponentType.Dropdown,
    isActiveStatus: false,
  },
  suffix: {
    name: "suffix",
    label: "Suffix",
    type: "text",
    component: InputComponentType.Dropdown,
  },
  lastName: {
    name: "lastName",
    label: "Last Name",
    type: "text",
    required: true,
    component: InputComponentType.TextField,
  },
  firstName: {
    name: "firstName",
    label: "First Name",
    type: "text",
    required: true,
    component: InputComponentType.TextField,
  },
  middleName: {
    name: "middleName",
    label: "Middle Name",
    type: "text",
    component: InputComponentType.TextField,
  },
  race: {
    name: "race",
    label: "Race",
    component: InputComponentType.Dropdown,
  },
  gender: {
    name: "gender",
    label: "Sex",
    component: InputComponentType.Dropdown,
  },
  dob: {
    name: "dob",
    label: "DOB",
    component: InputComponentType.DatePicker,
    disableFuture: true,
  },
  address: {
    name: "address",
    label: "Residential Address",
    type: "text",
    component: InputComponentType.TextField,
  },
  rCity: {
    name: "rCity",
    label: "Residential City",
    type: "text",
    component: InputComponentType.Dropdown,
    startIcon: true,
  },
  rState: {
    name: "rState",
    label: "Residential State",
    component: InputComponentType.Dropdown,
  },
  rZip: {
    name: "rZip",
    label: "Residential Zip",
    type: "text",
    isNumber: true,
    component: InputComponentType.TextField,
  },
  mAddress: {
    name: "mAddress",
    label: "Mailing Address",
    type: "text",
    component: InputComponentType.TextField,
  },
  mCity: {
    name: "mCity",
    label: "Mailing City",
    type: "text",
    component: InputComponentType.Dropdown,
    startIcon: true,
  },
  mState: {
    name: "mState",
    label: "Mailing State",
    component: InputComponentType.Dropdown,
  },
  mZip: {
    name: "mZip",
    label: "Mailing Zip",
    type: "text",
    isNumber: true,
    component: InputComponentType.TextField,
  },
  phoneNo: {
    name: "phoneNo",
    label: "Home Phone",
    type: "text",
    component: InputComponentType.TextField,
    isPhoneNumber: true,
  },
  cellNo: {
    name: "cellNo",
    label: "Cellular Phone",
    type: "text",
    component: InputComponentType.TextField,
    isPhoneNumber: true,
  },
  pagerNo: {
    name: "pagerNo",
    label: "Pager Number",
    type: "number",
    isNumber: true,
    component: InputComponentType.TextField,
  },
  workPhoneNum: {
    name: "workPhoneNum",
    label: "Office Number",
    type: "text",
    component: InputComponentType.TextField,
    isPhoneNumber: true,
  },
  email: {
    name: "email",
    label: "Email",
    type: "email",
    component: InputComponentType.TextField,
  },
  dl: {
    name: "dl",
    label: "Driver's Lic #",
    type: "text",
    component: InputComponentType.TextField,
  },
  dlState: {
    name: "dlState",
    label: "DL State",
    component: InputComponentType.Dropdown,
  },
  dlExpire: {
    name: "dlExpire",
    label: "DL Expiration",
    component: InputComponentType.DatePicker,
    isHighlited: true,
  },
  maritalStatus: {
    name: "maritalStatus",
    label: "Marital Status",
    component: InputComponentType.Dropdown,
  },
  spouseName: {
    name: "spouseName",
    label: "Spouse Name",
    type: "text",
    component: InputComponentType.TextField,
  },
  spouseSSN: {
    name: "spouseSSN",
    label: "Spouse SSN",
    type: "text",
    component: InputComponentType.TextField,
    isSSN: true,
  },
  spouseEmployer: {
    name: "spouseEmployer",
    label: "Spouse Employer",
    type: "text",
    component: InputComponentType.TextField,
  },
  spousePhoneNumber: {
    name: "spousePhoneNumber",
    label: "Spouse Phone Number",
    type: "text",
    component: InputComponentType.TextField,
    isPhoneNumber: true,
  },
  hireDate: {
    name: "hireDate",
    label: "Hire Date",
    component: InputComponentType.DatePicker,
  },
  latestHireDate: {
    name: "latestHireDate",
    label: "Latest Hire Date",
    component: InputComponentType.DatePicker,
  },
  commissionedDate: {
    name: "commissionedDate",
    label: "Commission Date",
    component: InputComponentType.DatePicker,
  },
  residentialCounty: {
    name: "residentialCounty",
    label: "Residential County",
    component: InputComponentType.Dropdown,
  },
  assignedCounty: {
    name: "assignedCounty",
    label: "Assigned County",
    component: InputComponentType.Dropdown,
  },
  badgeNum: {
    name: "badgeNum",
    label: "Badge/Rep#",
    type: "text",
    component: InputComponentType.TextField,
  },
};

export const medicalFields = [
  {
    name: "bloodType",
    label: "Employee Blood Type",
    type: "text",
    component: InputComponentType.Dropdown,
  },
  {
    name: "medicalNotes",
    label: "Medical Notes",
    type: "text",
    component: InputComponentType.TextField,
  },
];

export const payrollFields = [
  {
    name: "ssn",
    label: "SSN",
    type: "text",
    component: InputComponentType.TextField,
    isSSN: true,
  },
  {
    name: "positionNum",
    label: "Position #",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "masterCostCenter",
    label: "Master Cost Center",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "salary",
    label: "Salary",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "annualSalary",
    label: "Annual Salary",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "orgChart",
    label: "Org Chart",
    component: InputComponentType.Checkbox,
  },
  {
    name: "flsaStatus",
    label: "FLSA Status",
    component: InputComponentType.Radio,
  },
  {
    name: "titlePosition",
    label: "Title/Position",
    component: InputComponentType.Dropdown,
  },
  {
    name: "rank",
    label: "Rank",
    component: InputComponentType.Dropdown,
  },
  {
    name: "classCode",
    label: "Class Code",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "grade",
    label: "Grade",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "personnelNum",
    label: "Personnel Number",
    type: "text",
    isNumber: true,
    component: InputComponentType.TextField,
  },
  {
    name: "personnelArea",
    label: "Personnel Area",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "subArea",
    label: "Sub Area",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "orgUnit",
    label: "Org. Unit",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "contract",
    label: "Contract",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "positionStartDate",
    label: "Position Start",
    component: InputComponentType.DatePicker,
  },
  {
    name: "positionEndDate",
    label: "Position End",
    component: InputComponentType.DatePicker,
  },
  {
    name: "cgdg",
    label: "CG/DG",
    component: InputComponentType.Checkbox,
  },
  {
    name: "clip",
    label: "Clip",
    component: InputComponentType.Checkbox,
  },
  {
    name: "dateLwopMilitary",
    label: "Date LWOP Military Leave",
    component: InputComponentType.DatePicker,
  },
  {
    name: "dateReturnedPayroll",
    label: "Date Returned Active Payroll",
    component: InputComponentType.DatePicker,
  },
  {
    name: "perfRevDate",
    label: "Perf. Review Date",
    component: InputComponentType.DatePicker,
  },
  {
    name: "careerServiceDate",
    label: "Career Service Date",
    component: InputComponentType.DatePicker,
  },
  {
    name: "leaveAccDate",
    label: "Leave Accrual Date",
    component: InputComponentType.DatePicker,
  },
  {
    name: "careerServicePayment",
    label: "Career Service Payment",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "orderNum",
    label: "Order #",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "percentage",
    label: "Percentage",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "internalCC",
    label: "Internal CC",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "wbsElement",
    label: "WBS Element",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "wbscc",
    label: "WBS CC",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "otherCC",
    label: "Other CC",
    type: "text",
    component: InputComponentType.TextField,
  },
];

export const educationFields = [
  {
    name: "education",
    label: "Education",
    component: InputComponentType.Dropdown,
  },
  {
    name: "notes",
    label: "Reserves/Guard Related Notes",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "militaryNotes",
    label: "Military Related Notes",
    type: "text",
    component: InputComponentType.TextField,
  },
];

export const separationFields = [
  {
    name: "dropDate",
    label: "Drop Date",
    component: InputComponentType.DatePicker,
  },
  {
    name: "retireDate",
    label: "Retire Date",
    component: InputComponentType.DatePicker,
  },
  {
    name: "separationDate",
    label: "Term Date",
    component: InputComponentType.DatePicker,
  },
  {
    name: "separationCode",
    label: "Term Reason",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "separationComments",
    label: "Comments",
    type: "text",
    component: InputComponentType.TextField,
  },
  {
    name: "rehire",
    label: "Rehire?",
    component: InputComponentType.Radio,
  },
];
